import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { makeStyles, Tooltip } from '@material-ui/core';

import { getI18n } from "../../../utils/intl";

import styles from './styles';

const ChartLegend = (props) => {
  const { data, showUngroupedDataOnTooltip, hoverHandler, clickHandler } = props;

  const intl = getI18n(useIntl());
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const renderItemData = (item, parentShown) => {
    const { data } = item;
    const { id, component, disable, show } = data;
    let value = '';
    if (show) {
      value = data.value;
      if (value && !isNaN(value)) {
        value = `${Math.round(data.value * 100) / 100}${item.suffix}`;
      } else if (!value) {
        value = '';
      }
    }
    return (
      <div
        className={clsx(classes.legendItemData,
          { legendItemData__disable: disable },
        )}
        key={id}
        role={'button'}
        onClick={() => clickHandler(id, true)}
        onMouseEnter={parentShown ? (() => hoverHandler(id, true)) : null}
        onMouseLeave={parentShown ? (() => hoverHandler(id, false)) : null}
      >
        {component}
        <span>
          {intl.getI18nMessage(data.label)}
        </span>
        <span className={classes.legendItemDataValue}>
          {value}
        </span>
      </div>
    );
  };

  const renderItem = (objData) => {
    const { data, uuid, names, show, legendTooltipLabel } = objData;
    const tooltipContent = showUngroupedDataOnTooltip ?
      legendTooltipLabel.join(' ❯ ') : names.join(' ❯ ');
    return (
      <div className={classes.legendItem} key={uuid}>
        <div className={classes.legendItemName}>
          <Tooltip
            destroyTooltipOnHide
            placement={'top'}
            title={
              <div className={classes.tooltipContent}>
                {tooltipContent}
              </div>
            }
          >
            <div className={classes.itemName} id={'itemName'}>
              {names.join(' ❯ ')}
            </div>
          </Tooltip>
        </div>
        <div>
          {data.map(item => {
            const itemData = {
              data: item,
              suffix: objData.suffix ? objData.suffix : '',
            };
            return renderItemData(itemData, show);
          })}
        </div>
      </div>
    );
  };

  return (
    <div className={classes.legendContainer}>
      {data.map(renderItem)}
    </div>
  );
}

ChartLegend.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  hoverHandler: PropTypes.func,
  clickHandler: PropTypes.func,
  showUngroupedDataOnTooltip: PropTypes.bool,
}

export default ChartLegend;